<template>
    <dashboard-layout id="app">


        <template slot="sidebar-menu">
            <sidebar-link index="1" name="Requêtes d'inspection" i="ti-dashboard" to="dashboard">
            </sidebar-link>
            <sidebar-link index="2" name="Véhicules" i="ti-car" to="vehicles"></sidebar-link>
            <sidebar-link v-if="$store.getters.userIsAtLeastAdmin" index="3" name="Flottes" i="ti-folder"
                to="bases"></sidebar-link>
            <sidebar-link v-if="$store.getters.displayFleetsPage" index="4" name="Bases" i="ti-truck"
                to="fleets"></sidebar-link>
            <sidebar-link v-if="$store.getters.userIsAtLeastAdmin" index="5" name="KPI" i="ti-bar-chart"
                to="kpi"></sidebar-link>
            <sidebar-link v-if="$store.getters.isBridgestoneUser" index="6" name="Logs" i="ti-harddrives"
                to="logs"></sidebar-link>
            <sidebar-link index="7" name="Aide" i="ti-help-alt" to="help"></sidebar-link>
        </template>


    </dashboard-layout>
</template>

<script>
import { DashboardLayout } from 'fundation-app-vuejs';

export default {
    name: 'App',
    components: {
        DashboardLayout,
    },
};
</script>

<style lang="scss">
@import './main.scss';

html,
body {
    margin: 0px;
    padding: 0px;
}

#app {
    .simple-layout {
        background-color: #eee !important;

    }

}



.edit-user-modal {
    .el-form {
        .el-form-item:has(label[for*="client"]) {
            margin-bottom: 0.5 !important;

            &:after {
                content: 'Notifications:';
                display: block;
                font-weight: bold;
                margin-top: 2rem;
                margin-bottom: 0;
            }
        }

        .el-form-item:has(label[for*="enable_"]) {
            margin-bottom: 0 !important;

            label {
                width: auto !important;
            }

            .el-form-item__content {
                margin-left: 0 !important;
                display: flex;
                justify-content: flex-end;

                .el-switch {
                    margin-right: 250px !important;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue